<template>
    <div class="component forms-checkbox">
        <label v-if="label" v-html="label"></label>
        <div class="options">
            <v-checkbox
                    v-model="newValue"
                    v-bind:value="option.value"
                    v-for="(option, index) in options"
                    v-bind:id="`${id}_${index}`"
                    v-on:change="onChange"
                    v-bind:key="index"
            >
                <template v-slot:label class="label-slot">
                    <div class="label" v-html="option.text">
                    </div>
                </template>
            </v-checkbox>
        </div>
    </div>
</template>

<script type="text/babel">
    import {VCheckbox} from 'vuetify/lib'

    export default {
        name: 'components-forms-checkbox-index',
        watch: {
            value() {
                this.newValue = this.value;
            }
        },
        props: {
            value: undefined,
            id: undefined,
            type: {
                default: 'text'
            },
            label: {
                default: undefined
            },
            options: {
                required: true
            }
        },
        data() {
            return {
                newValue: undefined
            }
        },
        methods: {
            onChange() {
                this.$emit('input', this.newValue);
            }
        },
        computed: {},
        created() {
            if (!this.value) {
                this.newValue = [];
            } else {
                this.newValue = this.value;
            }
        },
        mounted() {
        },
        beforeDestroy() {
        },
        mixins: [],
        components: {
            VCheckbox
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .forms-checkbox {
        .label {
            top: 3px;
            position: relative;
        }

        .v-input {
            margin-top: 0px;
        }

        .v-input__slot {
            margin-bottom: 0px !important;
        }

        .v-messages {
            display: none;
        }

        .options {
            margin-bottom: 1em;
        }
    }
</style>
